/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

export const createHUAutocompleteStyles = makeStyles((theme: Theme) => ({
  root: {
    '& .MuiChip-root': {
      borderRadius: '6px',
      backgroundColor: theme.palette.primary.main,
      height: '34px',

      '& .MuiChip-label': {
        fontSize: '14px',
        lineHeight: '14px',
        fontWeight: 500,
        letterSpacing: '-0.11px',
        color: '#fff',
        padding: '0 12px',
      },

      '& svg': {
        color: theme.palette.primary.contrastText,
        opacity: '.7',
      },
    },
  },
  focused: {
    color: 'green',
    '& $popupIndicator': {
      color: theme.palette.primary.main,
    },
  },
  paper: {
    margin: '8px 0',
    boxShadow: 'none',
    border: '2px solid',
    borderColor: theme.palette.primary.main,
    borderRadius: '6px',
    color: theme.palette.text.secondary,
    fontSize: '16px',
  },
  groupLabel: {
    fontSize: '10px',
    lineHeight: '16px',
    fontWeight: 500,
    paddingBottom: '2px',
    paddingTop: '8px',
  },
  groupUl: {
    padding: 0,
  },
  endAdornment: {
    right: '10px',
    color: 'red',
  },
  popupIndicator: {
    '& svg': {
      fontSize: '24px',
    },
  },
  inputRoot: {
    paddingTop: '5px !important',
    paddingBottom: '6px !important',
  },
}));
